import { Card, Form, Select, Skeleton } from "antd";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { SettingContext } from "../../routes";
import HTTP from "../../services/httpService";
import { formatDate } from "../../services/util";
import CustomTable from "../common/Table";

const { Option } = Select;

function ErrorAnalytics() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const { selectedDates } = useContext(SettingContext);
    const [start_date, end_date] = selectedDates;
    const [hotelOptions, setHotelOptions] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [formData, setFormData] = useState({
        staff_id,
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        all_selected: true,
        hotel_ids: [],
    });

    const columns = [
        {
            title: "Hotel Id",
            dataIndex: "hotel_id",
            key: "hotel_id",
        },
        {
            title: "Hotel Name",
            dataIndex: "hotel_name",
            key: "hotel_name",
        },
        {
            title: "Error",
            dataIndex: "errors",
            key: "errors",
        },
    ];

    const {
        status: hotelStatus,
        data: hotelData,
        refetch: getHotelSelectionOptions,
    } = useQuery(
        "analytics-hotels",
        async () => {
            return await HTTP("/dashboard/getHotels", {
                staff_id,
                hotel_type: "all",
            });
        },
        { enabled: false },
    );

    const {
        status: tableStatus,
        data: tableRes,
        refetch: getTableData,
    } = useQuery(
        "error-analytics",
        async () => {
            return await HTTP("/dashboard/getSplunkErrorCounts", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        if (tableStatus == "success") {
            setTableData(tableRes.data);
        }
    }, [tableStatus, tableRes]);

    useEffect(() => {
        if (hotelStatus === "success") {
            setHotelOptions(hotelData.data);
        }
    }, [hotelStatus, hotelData]);

    useEffect(() => {
        getTableData();
    }, [formData]);

    useEffect(() => {
        getTableData();
        getHotelSelectionOptions();
    }, []);

    function handleHotelSelection(e) {
        setFormData({
            ...formData,
            hotel_ids: e,
            all_selected: e.length > 0 ? false : true,
        });
    }

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    return (
        <Card>
            <Form
                labelCol={{
                    span: 4,
                }}
                wrapperCol={{
                    span: 6,
                }}
            >
                <Form.Item label="Hotels" name="hotel_id">
                    <Select
                        id="hotel_id"
                        placeholder="Hotel Name"
                        className="jira-dashboard-select"
                        showSearch
                        mode="multiple"
                        onChange={handleHotelSelection}
                        filterOption={(input, option) =>
                            option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                        loading={hotelOptions.length == 0}
                    >
                        {hotelOptions.map((h) => (
                            <Option
                                key={h.hotel_id || h.id}
                                value={h.hotel_id || h.id}
                            >
                                {`${h.hotel_id || h.id} - ${
                                    h.hotel_name || h.name
                                } - ${h.city}`}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
            {tableStatus !== "loading" && tableStatus !== "idle" ? (
                <CustomTable
                    columns={columns}
                    tableData={tableData}
                    rowKey="hotel_id"
                />
            ) : (
                <Skeleton />
            )}
        </Card>
    );
}

export { ErrorAnalytics };
